module.exports = __webpack_public_path__ + "img/k05.3b9c1d2f.png";